module.exports = __webpack_public_path__ + "img/Vector1@2x.0c8ea559.png";